<script>
  import LiveStripe from './LiveStripe.svelte';
  import LiveTeams from './LiveTeams.svelte';
  import LiveInning from './LiveInning.svelte';
  import LiveBases from './LiveBases.svelte';
  import LiveState from './LiveState.svelte';

  export let value;

  $: if (value) value.color = 'red';
</script>

<div class='live'>
  <div class='live-main'>
    <div class='live-main-bar'>
      <LiveStripe bind:value={value}/>
    </div>

    <div class='live-main-content'>
      <LiveTeams bind:value={value}/>

      <LiveInning bind:value={value}/>
    </div>
  </div>

  <LiveBases bind:value={value}/>

  <LiveState bind:value={value}/>
</div>

<style>
  .live {
    display: flex;
    gap: 7.5px;
  }

  .live-main {
    display: flex;
    flex-direction: column;
    gap: 7.5px;
  }

  .live-main-content {
    display: flex;
    gap: 7.5px;
  }
</style>
